import React from 'react';
import { FormGroup, Label, Input, Button, Row, Col } from 'reactstrap';
import TextStyleInputs from './TextStyleInputs';
import ColorPickerInput from './ColorPickerInput';

const HeroSectionTab = ({
    hero = {},
    updateLocalHeroConfig,
    updateLocalHeroTitleConfig,
    updateLocalHeroLeadGraphicConfig,
    updateLocalHeroCTAConfig,
}) => {
    return (
        <div>
            {/* Section: Hero Styling */}
            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">Hero-Bereich & CTA</h2>
                <FormGroup className="mb-3">
                    <Label for="heroBackground">Hintergrundtyp</Label>
                    <Input
                        type="select"
                        id="heroBackground"
                        value={hero.background}
                        onChange={(e) => updateLocalHeroConfig({ background: e.target.value })}
                    >
                        <option value="keyVisual">Key-Visual-Bild</option>
                        <option value="solid">Einfarbige Füllung</option>
                    </Input>
                </FormGroup>

                <ColorPickerInput
                    id="heroSolidColor"
                    label="Einfarbiger Hintergrund"
                    value={hero.solidColor}
                    onChange={(val) => updateLocalHeroConfig({ solidColor: val })}
                    placeholder="z.B. #ffffff oder transparent"
                />

                {hero.background === 'keyVisual' && (
                    <FormGroup className="mb-3">
                        <Label for="heroKeyVisualSplit">Key-Visual-Teilung (Split)</Label>
                        <Input
                            type="select"
                            id="heroKeyVisualSplit"
                            value={hero.keyVisualSplit || 'full'}
                            onChange={(e) => updateLocalHeroConfig({ keyVisualSplit: e.target.value })}
                        >
                            <option value="full">Volle Breite (Standard)</option>
                            <option value="split-left">Teilung links (Bild links, einfarbig rechts)</option>
                            <option value="split-right">Teilung rechts (Bild rechts, einfarbig links)</option>
                        </Input>
                    </FormGroup>
                )}

                <FormGroup switch className="mb-2">
                    <Input
                        type="switch"
                        id="hasTitle"
                        checked={hero.title?.hasTitle}
                        onChange={(e) => updateLocalHeroTitleConfig({ hasTitle: e.target.checked })}
                    />
                    <Label check for="hasTitle">
                        Titel anzeigen
                    </Label>
                </FormGroup>

                {hero.title?.hasTitle && (
                    <div className="ps-3 border-start mb-3">
                        <FormGroup className="mb-3">
                            <Label for="heroTitleText">Titeltext</Label>
                            <Input
                                type="text"
                                id="heroTitleText"
                                value={hero.title.text || ''}
                                onChange={(e) => updateLocalHeroTitleConfig({ text: e.target.value })}
                                placeholder="Geben Sie einen Titel ein..."
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroSubtitleText">Untertiteltext</Label>
                            <Input
                                type="text"
                                id="heroSubtitleText"
                                value={hero.title.subtitleText || ''}
                                onChange={(e) => updateLocalHeroTitleConfig({ subtitleText: e.target.value })}
                                placeholder="Geben Sie einen Untertitel ein..."
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroTitleHorizontalPosition">Horizontale Position</Label>
                            <Input
                                type="select"
                                id="heroTitleHorizontalPosition"
                                value={hero.title.horizontalPosition}
                                onChange={(e) => updateLocalHeroTitleConfig({ horizontalPosition: e.target.value })}
                            >
                                <option value="left">Links</option>
                                <option value="center">Zentriert</option>
                                <option value="right">Rechts</option>
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroTitleVerticalPosition">Vertikale Position</Label>
                            <Input
                                type="select"
                                id="heroTitleVerticalPosition"
                                value={hero.title.verticalPosition}
                                onChange={(e) => updateLocalHeroTitleConfig({ verticalPosition: e.target.value })}
                            >
                                <option value="top">Oben</option>
                                <option value="center">Zentriert</option>
                                <option value="bottom">Unten</option>
                            </Input>
                        </FormGroup>

                        <TextStyleInputs
                            label="Schriftstil: Titeltext"
                            styleConfig={hero.title.textStyle}
                            onChange={(style) => updateLocalHeroTitleConfig({ textStyle: style })}
                        />
                        <TextStyleInputs
                            label="Schriftstil: Untertitel"
                            styleConfig={hero.title.subtitleStyle}
                            onChange={(style) => updateLocalHeroTitleConfig({ subtitleStyle: style })}
                        />
                    </div>
                )}

                <FormGroup switch className="mb-2">
                    <Input
                        type="switch"
                        id="hasLeadGraphic"
                        checked={hero.leadGraphic?.hasLeadGraphic}
                        onChange={(e) => updateLocalHeroLeadGraphicConfig({ hasLeadGraphic: e.target.checked })}
                    />
                    <Label check for="hasLeadGraphic">
                        Lead-Grafik anzeigen
                    </Label>
                </FormGroup>

                {hero.leadGraphic?.hasLeadGraphic && (
                    <div className="ps-3 border-start mb-3">
                        <FormGroup className="mb-3">
                            <Label for="heroLeadGraphicHorizontalPosition">Horizontale Position</Label>
                            <Input
                                type="select"
                                id="heroLeadGraphicHorizontalPosition"
                                value={hero.leadGraphic.horizontalPosition || 'left'}
                                onChange={(e) =>
                                    updateLocalHeroLeadGraphicConfig({ horizontalPosition: e.target.value })
                                }
                            >
                                <option value="left">Links</option>
                                <option value="center">Zentriert</option>
                                <option value="right">Rechts</option>
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroLeadGraphicVerticalPosition">Vertikale Position</Label>
                            <Input
                                type="select"
                                id="heroLeadGraphicVerticalPosition"
                                value={hero.leadGraphic.verticalPosition || 'top'}
                                onChange={(e) => updateLocalHeroLeadGraphicConfig({ verticalPosition: e.target.value })}
                            >
                                <option value="top">Oben</option>
                                <option value="center">Zentriert</option>
                                <option value="bottom">Unten</option>
                            </Input>
                        </FormGroup>

                        <div className="mb-2 text-muted small">Grafik-Breakpoints:</div>

                        {(hero.leadGraphic?.breakpoints || []).map((bp, idx) => (
                            <div key={idx} className="p-3 border rounded mb-3 bg-white">
                                <Row className="g-2 mb-2">
                                    <Col xs="4">
                                        <Label className="small text-muted mb-1">Min. Breite (px)</Label>
                                        <Input
                                            type="number"
                                            value={bp.minWidth}
                                            onChange={(e) => {
                                                const currentBps = [...(hero.leadGraphic?.breakpoints || [])];
                                                currentBps[idx] = {
                                                    ...currentBps[idx],
                                                    minWidth: parseInt(e.target.value, 10) || 0,
                                                };
                                                updateLocalHeroLeadGraphicConfig({
                                                    breakpoints: currentBps,
                                                });
                                            }}
                                            placeholder="Min. Breite"
                                        />
                                    </Col>
                                    <Col xs="4">
                                        <Label className="small text-muted mb-1">Skalierung</Label>
                                        <Input
                                            type="number"
                                            value={bp.scale !== undefined && bp.scale !== null ? bp.scale : 1}
                                            min={0.1}
                                            max={2}
                                            step={0.05}
                                            onChange={(e) => {
                                                const currentBps = [...(hero.leadGraphic?.breakpoints || [])];
                                                currentBps[idx] = {
                                                    ...currentBps[idx],
                                                    scale: parseFloat(e.target.value) || 1,
                                                };
                                                updateLocalHeroLeadGraphicConfig({
                                                    breakpoints: currentBps,
                                                });
                                            }}
                                            placeholder="Skalierung"
                                        />
                                    </Col>
                                    <Col xs="4">
                                        <Label className="small text-muted mb-1">Max. Höhe (px)</Label>
                                        <Input
                                            type="number"
                                            value={
                                                bp.maxHeight !== undefined && bp.maxHeight !== null ? bp.maxHeight : ''
                                            }
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                const currentBps = [...(hero.leadGraphic?.breakpoints || [])];
                                                currentBps[idx] = {
                                                    ...currentBps[idx],
                                                    maxHeight: val === '' ? undefined : parseInt(val, 10) || undefined,
                                                };
                                                updateLocalHeroLeadGraphicConfig({
                                                    breakpoints: currentBps,
                                                });
                                            }}
                                            placeholder="Automatisch"
                                        />
                                    </Col>
                                </Row>
                                <Row className="g-2 mb-2">
                                    <Col xs="6">
                                        <Label className="small text-muted mb-1">Fokuspunkt X (%)</Label>
                                        <Input
                                            type="number"
                                            value={
                                                bp.focalPoint &&
                                                bp.focalPoint.x !== undefined &&
                                                bp.focalPoint.x !== null
                                                    ? bp.focalPoint.x
                                                    : 50
                                            }
                                            min={0}
                                            max={100}
                                            onChange={(e) => {
                                                const currentBps = [...(hero.leadGraphic?.breakpoints || [])];
                                                currentBps[idx] = {
                                                    ...currentBps[idx],
                                                    focalPoint: {
                                                        ...(currentBps[idx].focalPoint || { x: 50, y: 50 }),
                                                        x: parseInt(e.target.value, 10) || 0,
                                                    },
                                                };
                                                updateLocalHeroLeadGraphicConfig({
                                                    breakpoints: currentBps,
                                                });
                                            }}
                                            placeholder="Fokuspunkt X"
                                        />
                                    </Col>
                                    <Col xs="6">
                                        <Label className="small text-muted mb-1">Fokuspunkt Y (%)</Label>
                                        <Input
                                            type="number"
                                            value={
                                                bp.focalPoint &&
                                                bp.focalPoint.y !== undefined &&
                                                bp.focalPoint.y !== null
                                                    ? bp.focalPoint.y
                                                    : 50
                                            }
                                            min={0}
                                            max={100}
                                            onChange={(e) => {
                                                const currentBps = [...(hero.leadGraphic?.breakpoints || [])];
                                                currentBps[idx] = {
                                                    ...currentBps[idx],
                                                    focalPoint: {
                                                        ...(currentBps[idx].focalPoint || { x: 50, y: 50 }),
                                                        y: parseInt(e.target.value, 10) || 0,
                                                    },
                                                };
                                                updateLocalHeroLeadGraphicConfig({
                                                    breakpoints: currentBps,
                                                });
                                            }}
                                            placeholder="Fokuspunkt Y"
                                        />
                                    </Col>
                                </Row>
                                <Row className="g-2 align-items-end">
                                    <Col>
                                        <Label className="small text-muted mb-1">Grafik-URL</Label>
                                        <Input
                                            type="text"
                                            value={bp.url}
                                            onChange={(e) => {
                                                const currentBps = [...(hero.leadGraphic?.breakpoints || [])];
                                                currentBps[idx] = { ...currentBps[idx], url: e.target.value };
                                                updateLocalHeroLeadGraphicConfig({
                                                    breakpoints: currentBps,
                                                });
                                            }}
                                            placeholder="Grafik-URL"
                                        />
                                    </Col>
                                    <Col xs="auto">
                                        <Button
                                            color="danger"
                                            onClick={() => {
                                                const currentBps = (hero.leadGraphic?.breakpoints || []).filter(
                                                    (_, i) => i !== idx
                                                );
                                                updateLocalHeroLeadGraphicConfig({
                                                    breakpoints: currentBps,
                                                });
                                            }}
                                        >
                                            Löschen
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        ))}

                        <Button
                            color="primary"
                            outline
                            className="w-100"
                            onClick={() => {
                                const currentBps = [
                                    ...(hero.leadGraphic?.breakpoints || []),
                                    { minWidth: 0, url: '', focalPoint: { x: 50, y: 50 } },
                                ];
                                updateLocalHeroLeadGraphicConfig({
                                    breakpoints: currentBps,
                                });
                            }}
                        >
                            Breakpoint hinzufügen
                        </Button>

                        <FormGroup switch className="mb-2 mt-2">
                            <Input
                                type="switch"
                                id="leadGraphicAltSwitch"
                                checked={hero.leadGraphic?.altText === ''}
                                onChange={(e) => {
                                    updateLocalHeroLeadGraphicConfig({
                                        altText: e.target.checked ? '' : undefined,
                                    });
                                }}
                            />
                            <Label check for="leadGraphicAltSwitch">
                                Als dekorativ markieren (leerer Alt-Text)
                            </Label>
                        </FormGroup>

                        {hero.leadGraphic?.altText !== '' && (
                            <FormGroup className="mb-3">
                                <Label for="leadGraphicAltText">Grafik-Alt-Text</Label>
                                <Input
                                    type="text"
                                    id="leadGraphicAltText"
                                    value={hero.leadGraphic?.altText || ''}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        updateLocalHeroLeadGraphicConfig({
                                            altText: val === '' ? undefined : val,
                                        });
                                    }}
                                    placeholder="Standard: Untertitel"
                                />
                            </FormGroup>
                        )}
                    </div>
                )}

                <FormGroup switch className="mb-2">
                    <Input
                        type="switch"
                        id="hasCTA"
                        checked={hero.cta?.hasCTA}
                        onChange={(e) => updateLocalHeroCTAConfig({ hasCTA: e.target.checked })}
                    />
                    <Label check for="hasCTA">
                        CTA-Block anzeigen
                    </Label>
                </FormGroup>

                {hero.cta?.hasCTA && (
                    <div className="ps-3 border-start mb-3">
                        <FormGroup switch className="mb-3">
                            <Input
                                type="switch"
                                id="hasNoCard"
                                checked={hero.cta.card?.hasNoCard || false}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        card: {
                                            ...(hero.cta.card || {}),
                                            hasNoCard: e.target.checked,
                                        },
                                    })
                                }
                            />
                            <Label check for="hasNoCard">
                                Kein Karten-Rahmen (No Card Wrapper Style)
                            </Label>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroCtaTitleText">CTA-Titel</Label>
                            <Input
                                type="text"
                                id="heroCtaTitleText"
                                value={hero.cta.title?.text || ''}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        title: {
                                            ...(hero.cta.title || {}),
                                            text: e.target.value,
                                        },
                                    })
                                }
                                placeholder="CTA Überschrift..."
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroCtaBodyText">CTA-Beschreibung</Label>
                            <Input
                                type="textarea"
                                id="heroCtaBodyText"
                                value={hero.cta.body?.text || ''}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        body: {
                                            ...(hero.cta.body || {}),
                                            text: e.target.value,
                                        },
                                    })
                                }
                                placeholder="CTA Beschreibungstext..."
                                rows={2}
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroCtaButtonText">Button-Text</Label>
                            <Input
                                type="text"
                                id="heroCtaButtonText"
                                value={hero.cta.button?.text || ''}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        button: {
                                            ...(hero.cta.button || {}),
                                            text: e.target.value,
                                        },
                                    })
                                }
                                placeholder="Button Text..."
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroCtaButtonLinkUrl">Button-Ziel-URL</Label>
                            <Input
                                type="text"
                                id="heroCtaButtonLinkUrl"
                                value={hero.cta.button?.linkUrl || ''}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        button: {
                                            ...(hero.cta.button || {}),
                                            linkUrl: e.target.value,
                                        },
                                    })
                                }
                                placeholder="/bewerbung"
                            />
                        </FormGroup>

                        <ColorPickerInput
                            id="heroCtaButtonColor"
                            label="Button-Farbe"
                            value={hero.cta.button?.color || ''}
                            onChange={(val) =>
                                updateLocalHeroCTAConfig({
                                    button: {
                                        ...(hero.cta.button || {}),
                                        color: val,
                                    },
                                })
                            }
                            placeholder="z.B. #005AAA"
                        />

                        <FormGroup className="mb-3">
                            <Label for="heroCtaHorizontalPosition">Horizontale Position</Label>
                            <Input
                                type="select"
                                id="heroCtaHorizontalPosition"
                                value={hero.cta.horizontalPosition}
                                onChange={(e) => updateLocalHeroCTAConfig({ horizontalPosition: e.target.value })}
                            >
                                <option value="left">Links</option>
                                <option value="center">Zentriert</option>
                                <option value="right">Rechts</option>
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroCtaVerticalPosition">Vertikale Position</Label>
                            <Input
                                type="select"
                                id="heroCtaVerticalPosition"
                                value={hero.cta.verticalPosition}
                                onChange={(e) => updateLocalHeroCTAConfig({ verticalPosition: e.target.value })}
                            >
                                <option value="top">Oben</option>
                                <option value="center">Zentriert</option>
                                <option value="bottom">Unten</option>
                            </Input>
                        </FormGroup>

                        <FormGroup switch className="mb-3">
                            <Input
                                type="switch"
                                id="isButtonOutlined"
                                checked={hero.cta.button?.isOutlined || false}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        button: {
                                            ...(hero.cta.button || {}),
                                            isOutlined: e.target.checked,
                                        },
                                    })
                                }
                            />
                            <Label check for="isButtonOutlined">
                                Outlined Button-Stil (nur Rahmen)
                            </Label>
                        </FormGroup>

                        <FormGroup switch className="mb-3">
                            <Input
                                type="switch"
                                id="isButtonVisible"
                                checked={hero.cta.button?.isVisible || false}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        button: {
                                            ...(hero.cta.button || {}),
                                            isVisible: e.target.checked,
                                        },
                                    })
                                }
                            />
                            <Label check for="isButtonVisible">
                                Button anzeigen
                            </Label>
                        </FormGroup>

                        <ColorPickerInput
                            id="heroCtaCardBackgroundColor"
                            label="CTA Hintergrundfarbe"
                            value={hero.cta.card?.backgroundColor || ''}
                            onChange={(val) =>
                                updateLocalHeroCTAConfig({
                                    card: {
                                        ...(hero.cta.card || {}),
                                        backgroundColor: val,
                                    },
                                })
                            }
                            placeholder="Standard: rgba(255, 255, 255, 0.94)"
                        />

                        <FormGroup className="mb-3">
                            <Label for="heroCtaCardBorder">CTA Rahmen (Border, z.B. none, 1px solid #000)</Label>
                            <Input
                                type="text"
                                id="heroCtaCardBorder"
                                value={hero.cta.card?.border || ''}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        card: {
                                            ...(hero.cta.card || {}),
                                            border: e.target.value || undefined,
                                        },
                                    })
                                }
                                placeholder="Standard: 1px solid rgba(255, 255, 255, 0.3)"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroCtaCardBackdropFilter">
                                CTA Hintergrund-Weichzeichner (Backdrop Filter, z.B. none, blur(12px))
                            </Label>
                            <Input
                                type="text"
                                id="heroCtaCardBackdropFilter"
                                value={hero.cta.card?.backdropFilter || ''}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        card: {
                                            ...(hero.cta.card || {}),
                                            backdropFilter: e.target.value || undefined,
                                        },
                                    })
                                }
                                placeholder="Standard: blur(12px)"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="heroCtaCardBoxShadow">
                                CTA Schatten (Box Shadow, z.B. none, 0 4px 12px rgba(0,0,0,0.15))
                            </Label>
                            <Input
                                type="text"
                                id="heroCtaCardBoxShadow"
                                value={hero.cta.card?.boxShadow || ''}
                                onChange={(e) =>
                                    updateLocalHeroCTAConfig({
                                        card: {
                                            ...(hero.cta.card || {}),
                                            boxShadow: e.target.value || undefined,
                                        },
                                    })
                                }
                                placeholder="Standard: kein Schatten (bzw. nach Bootstrap-Theme)"
                            />
                        </FormGroup>

                        <TextStyleInputs
                            label="Schriftstil: CTA-Überschrift"
                            styleConfig={hero.cta.title?.style}
                            onChange={(style) =>
                                updateLocalHeroCTAConfig({
                                    title: {
                                        ...(hero.cta.title || {}),
                                        style: style,
                                    },
                                })
                            }
                        />
                        <TextStyleInputs
                            label="Schriftstil: CTA-Beschreibung"
                            styleConfig={hero.cta.body?.style}
                            onChange={(style) =>
                                updateLocalHeroCTAConfig({
                                    body: {
                                        ...(hero.cta.body || {}),
                                        style: style,
                                    },
                                })
                            }
                        />
                        <TextStyleInputs
                            label="Schriftstil: CTA-Button"
                            styleConfig={hero.cta.button?.style}
                            onChange={(style) =>
                                updateLocalHeroCTAConfig({
                                    button: {
                                        ...(hero.cta.button || {}),
                                        style: style,
                                    },
                                })
                            }
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default HeroSectionTab;
